import script from "./OperatorCabinetAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorCabinetAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorCabinetAvatar.vue?vue&type=style&index=0&id=55fa395c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55fa395c"]])

export default __exports__